/**
 * EVENT_ACTIONS actions performed with/on the widget
 */
export var EVENT_ACTIONS = {
  DISPLAY: 'DISPLAY',
  PRESS: 'PRESS',
  COMPLETE: 'COMPLETE',
  FAIL: 'FAIL',
  START: 'START'
};